import * as React from 'react';
import { Api, ArrowBack, AutoAwesomeMosaic, PanToolAlt, Slideshow, Task, TextFields, Widgets } from "@mui/icons-material";
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputLabel, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, MenuItem, Popover, Select, SvgIcon, Switch, TextField, Tooltip } from "@mui/material";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { styled } from '@mui/material/styles';
import Service from '../../../util/Service';
import SlideShowDialog from './widget/SlideShowDialog';
import APIPageDialog from './widget/APIPageDialog';
import BuscaListaDialog from './widget/BuscaListaDialog';
import TarefaTable from './widget/TarefaTable';
import KanbansProjeto from './widget/KanbansProjeto';
import ActionFieldDialog from './widget/ActionFieldDialog';


const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));
export default function WidgetPopover(props) {
    const { onSelect, code, refDiv, refreshEditor, element } = props;
    const [showList, setShowList]= React.useState('main');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [clonedContent, setClonedContent] = React.useState(null);
    const [openDialogApi, setOpenDialogApi] = React.useState(false);
    const [openDialogSlide, setOpenDialogSlide] = React.useState(false);
    const [openDialogBuscaLista, setOpenDialogBuscaLista] = React.useState(false);
    const [marcado, setMarcado] = React.useState();
    const [paginas, setPaginas] = React.useState();
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    // React.useEffect(() => {
    //     if (open) {
    //         console.log('>>>>>', element)
    //         if( !element) return;
    //         const s = window.getSelection();
    //         // if (s.rangeCount === 0) {
    //         //     handleClose();                
    //         //     return;
    //         // }
    //         const range = s.getRangeAt(0);//s.baseNode;
    //         const cc = range.commonAncestorContainer;//.cloneContents(); //extractContents();            
    //         console.log( cc );   
    //         setMarcado(cc); 
    //         // setClonedContent(cc);
    //         if (s.rangeCount > 0 && checkValidEditor()) {
    //             const range = s.getRangeAt(0);//s.baseNode;
    //             const cc = range.startContainer;//.cloneContents(); //extractContents();  
    //             console.log( cc );    
    //             setClonedContent(cc);
    //         }
    //     }
    // }, [open]);

    React.useEffect(() => {
        if (open) {
            const s = window.getSelection();
            if (s.rangeCount === 0) {
                handleClose();
                return;
            }
            if (s.rangeCount > 0 && checkValidEditor()) {
                const range = s.getRangeAt(0);
                const cc = range.startContainer;
                setClonedContent(cc);
            }
        }
    }, [open]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setShowList('main');
    };

    const handleClickOpenDialogApi = () => {
        setOpenDialogApi(true);
    };
    const handleClickOpenDialogSlide = () => {
        setOpenDialogSlide(true);
    }
    const handleClickOpenBuscaLista = () => {
        setOpenDialogBuscaLista(true);
    }
    const handleCloseDialogApi = () => {
        setOpenDialogApi(false);
    };
    const handleBottomNav=()=>{
        Service.GET("/api/security/model/bottomNav").then(r => {
            console.log( r )
            if (r.success) {
                const div = document.createElement("div");
                div.innerHTML = r.html;

                refDiv.current.appendChild(div);
            }else {
                alert(r.msg)
            }
        });
    }
    const handleChoiseDialog=()=>{
        Service.GET("/api/security/model/choiceDialog").then(r => {
            console.log( r )
            if (r.success) {
                const div = document.createElement("div");
                div.innerHTML = r.html;
                const js = refDiv.current.querySelector("script");
                if( js ){
                    var jsOld =js.textContent;
                    jsOld +="\n\n"+r.js 
                    js.textContent = jsOld;
                }else{
                    const s = document.createElement("script");
                    s.setAttribute('execute-react', true);
                    s.textContent = r.js;
                    refDiv.current.prepend(s);    
                }

                const st = refDiv.current.querySelector("style");
                if( st ){
                    // st.appendChild(r.css)
                    var jsOld =st.textContent;
                    jsOld +="\n\n"+r.css 
                    st.textContent = jsOld;
                }else{
                    const s = document.createElement("style");
                    s.textContent = r.css;
                    refDiv.current.prepend(s);    
                }
                const divBtn = document.createElement("div");
                // btn.textContent = "Teste ListDialog"
                // btn.addEventListener('click', 'populaLista')

                divBtn.innerHTML = `
                    <button onclick="escolheLista();">Show ListDialog</button>
                `

                refDiv.current.appendChild(divBtn);
                refDiv.current.appendChild(div);
                handleClose();
                refreshEditor();
            } else {
                alert(r.msg)
            }
        })
    }
    
    const checkValidEditor = () => {
        const s = window.getSelection();
        if (s.rangeCount > 0) {
            const range = s.getRangeAt(0);//s.baseNode;
            const cc = range.startContainer;//.cloneContents(); //extractContents();      
            const pai = cc.parentNode;
            return (pai.id === "very2Editor")
        }
        return false;
    }
    function handleOpenFormTable() {
        console.log(">>handleOpenFormTable<<")
        let qtd = prompt("Por favor informe a quantidade de campos", 5);
        handleClose();
        if (qtd && qtd > 0) {
            const dado = {
                code: code,
                qtdCampos: qtd
            }
            Service.POST("/api/security/model/formTable", dado).then(r => {
                console.log(r);
                if (r.success) {
                    refDiv.current.innerHTML = r.dado;
                    //TODO
                } else {
                    alert(r.msg)
                }
            })
        }
    }
    function mostraListaThymeleft(){
        if( showList !== 'thymeleft')return;
        return (
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} dense>
                <ListItem sx={{ cursor: 'pointer' }} onClick={() => setShowList('main')}>
                    <ListItemIcon >
                        <IB size="small">
                            <ArrowBack />
                        </IB>
                    </ListItemIcon>
                    <ListItemText primary="Widget" secondary="Modelo básico" />
                </ListItem>
                <TarefaTable marcado={marcado} refDiv={refDiv} action={handleClose} />
                <KanbansProjeto marcado={marcado} refDiv={refDiv} action={handleClose} />
            </List>
        )
    }
    function mostraListaNormal(){
        if( showList !== 'main')return;
        return (
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} dense>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={()=>setShowList('thymeleft')}>
                        <ListItemIcon>
                            <IconButton size="small">
                                <img src='/thymeleaf.ico' width='25px' height='25px'/>
                            </IconButton>
                        </ListItemIcon>
                        <ListItemText primary="Backend-side" secondary="Paginas Thymeleaf" />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={handleOpenFormTable}>
                        <ListItemIcon>
                            <IconButton size="small">
                                <TextFields />
                            </IconButton>
                        </ListItemIcon>
                        <ListItemText primary="Formulário Tabela" secondary="Guarda form em uma tabela" />
                    </ListItem>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={handleClickOpenDialogApi}>
                        <ListItemIcon>
                            <IconButton size="small">
                                <Api />
                            </IconButton>
                        </ListItemIcon>
                        <ListItemText primary="Gerar Pagina API" secondary="Pagina a partir de uma API" />
                    </ListItem>

                    <ListItem sx={{ cursor: 'pointer' }} onClick={handleClickOpenDialogSlide} >
                        <ListItemIcon>
                            <IconButton size="small"
                                color={(element && element.getAttribute("compname") === 'verySlideshow') ? 'primary' : 'secundary'}
                            >
                                <Slideshow />
                            </IconButton>
                        </ListItemIcon>
                        <ListItemText primary="Slideshow" secondary="Slideshow componente Carousel" />
                    </ListItem>

                    <ListItem sx={{ cursor: 'pointer' }} onClick={handleClickOpenBuscaLista} >
                        <ListItemIcon>
                            <IconButton size="small">
                                <ManageSearchIcon />
                            </IconButton>
                        </ListItemIcon>
                        <ListItemText primary="Busca" secondary="Busca de uma lista" />
                    </ListItem>

                    <ListItem sx={{ cursor: 'pointer' }} onClick={handleChoiseDialog} >
                        <ListItemIcon>
                            <IconButton size="small">
                                <img width="24px" height="24px" src="/svg/choice.svg"/>
                            </IconButton>
                        </ListItemIcon>
                        <ListItemText primary="Escolha" secondary="Lista Dialog" />
                    </ListItem>
                    <ActionFieldDialog refDiv={refDiv} close={handleClose} refresh={refreshEditor} />
                    <ListItem sx={{ cursor: 'pointer' }} onClick={handleBottomNav} >
                        <ListItemIcon>
                            <IconButton size="small">
                                <PanToolAlt />
                            </IconButton>
                        </ListItemIcon>
                        <ListItemText primary="Navegação" secondary="Ferramenta de Navegação" />
                    </ListItem>
                </List>
        )
    }
    return (
        <React.Fragment>
            <Tooltip title="Widget">
                <IB
                    color={element ? 'primary' : 'secundary'}
                    onClick={handleClick}
                    size="small"
                >
                    <Widgets />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {mostraListaThymeleft()}
                {mostraListaNormal()}
            </Popover>
            <APIPageDialog
                refDiv={refDiv}
                open={openDialogApi}
                onClose={handleCloseDialogApi}
                closePai={handleClose}
                onSelect={onSelect}
                // clonedContent={clonedContent}
                refreshEditor={refreshEditor}
                element={element}
            />
            <BuscaListaDialog
                refDiv={refDiv}
                open={openDialogBuscaLista}
                onClose={() => setOpenDialogBuscaLista(false)}
                closePai={handleClose}
                onSelect={onSelect}
                clonedContent={clonedContent}
                refreshEditor={refreshEditor}
                element={element}
            />
            <SlideShowDialog
                open={openDialogSlide} setOpen={setOpenDialogSlide}
                onSelect={onSelect} code={code}
                clonedContent={clonedContent}
                closePai={handleClose}
                refDiv={refDiv}
                refreshEditor={refreshEditor}
                paginas={paginas} setPaginas={setPaginas}
                element={element}
            />
        </React.Fragment>
    )
}